<template>
  <div>
      <h2 class="mt-5">Upload Segment</h2>
     <ExcelVue :sheet="sampleExcel" :fname="filename"/>
  </div>
</template>

<script>
import ExcelVue from "@/components/ExcelSegment.vue";


export default {
  components: {
    ExcelVue
},
  data() {
    return {
      file: null, 
      filename:"FormSegment.xlsx",
      sampleExcel:[{ 
                    name: "SheetOne",  
                    data: [ 
                            {
                            "number_account":"TPXL",
                            "channel":"co",
                            "segment":"high"
                            }
                          ] 
                    }],
    };
  },
  methods: {
    onChange(event) {
      this.file = event.target.files ? event.target.files[0] : null;
    },
    test(){}

  },
  mounted(){
    
  }
 
};
</script>
<style scoped>
input[type="file"] {
    width: 50%;
    border: 1px solid black;
    padding: 5px 25px;
    border-radius: 5px;
}
</style>
